/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import './index.css';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import BookingPage from './pages/BookingPage';
import AuthPage from './pages/AuthPage';
import ListingPage from './pages/ListingPage';
import DashboardPage from './pages/DashboardPage';
import NewListingPage from './pages/NewListingPage';
import BecomeHostPage from './pages/BecomeHostPage';
import ReferralPage from './pages/ReferralPage';
import AdminPage from './pages/AdminPage';
import AdminLoginPage from './pages/AdminLoginPage';
import ReviewPage from './pages/ReviewPage';
import HowItWorksPage from './pages/HowItWorksPage';
import HostDocsPage from './pages/HostDocsPage';
import LegalPage from './pages/LegalPage';
import VoyageurPage from './pages/VoyageurPage';
import HotePage from './pages/HotePage';
import HavenlyPage from './pages/HavenlyPage';
import CommunityPage from './pages/CommunityPage';
import SettingsPage from './pages/SettingsPage';
import MyListingsPage from './pages/MyListingsPage';
import MyBookingsPage from './pages/MyBookingsPage';
import MessagesPage from './pages/MessagesPage';
import HostFounderPopup from './components/HostFounderPopup';
import FoundeursPage from './pages/FoundeursPage';
import ExitPopup from './components/ExitPopup';
import ConciergeriePage from './pages/ConciergeriePage';
import OwnerOnboardingPage from './pages/OwnerOnboardingPage';
import OwnerPortalPage from './pages/OwnerPortalPage';

/* ─── Bouton signalement ───────────────────────────────── */
function SignalementButton({ page }) {
  const [open, setOpen] = useState(false);
  const isMob = window.innerWidth < 768;
  const [msg, setMsg] = useState('');
  const [sent, setSent] = useState(false);
  const isDashboard = page === 'dashboard';
  const pos = isDashboard
    ? { bottom: 90, right: 20, left: 'auto' }
    : { bottom: 20, left: 20 };

  const send = async () => {
    if (!msg.trim()) return;
    await fetch('/api/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type: 'signalement',
        to: 'contact@havenly.fr',
        data: { message: msg, url: window.location.href, date: new Date().toLocaleString('fr-FR') },
      }),
    });
    setSent(true);
    setTimeout(() => { setOpen(false); setSent(false); setMsg(''); }, 2500);
  };

  return (
    <div style={{ position: 'fixed', ...pos, zIndex: 49998 }}>
      {open && (
        <div style={{ position: 'fixed', bottom: 70, left: '50%', transform: 'translateX(-50%)', background: '#fff', border: '1px solid #e0e0e0', borderRadius: 16, padding: '16px', width: 280, boxShadow: '0 8px 32px rgba(0,0,0,0.12)', zIndex: 49999 }}>
          {sent ? (
            <div style={{ textAlign: 'center', padding: '8px 0', fontSize: 14, color: '#0F6E56', fontWeight: 500 }}>Signalement envoye, merci !</div>
          ) : (
            <>
              <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 8, color: '#1A1A18' }}>Signaler un dysfonctionnement</div>
              <textarea value={msg} onChange={e => setMsg(e.target.value)} placeholder="Decrivez le probleme rencontre..."
                style={{ width: '100%', padding: '8px 10px', border: '1px solid #e0e0e0', borderRadius: 8, fontSize: 13, fontFamily: 'sans-serif', resize: 'vertical', minHeight: 80, outline: 'none', boxSizing: 'border-box', marginBottom: 10 }} />
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={send} disabled={!msg.trim()}
                  style={{ flex: 1, padding: '8px', background: msg.trim() ? '#1D9E75' : '#ccc', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: msg.trim() ? 'pointer' : 'default', fontFamily: 'sans-serif' }}>
                  Envoyer
                </button>
                <button onClick={() => setOpen(false)}
                  style={{ padding: '8px 12px', background: 'transparent', border: '1px solid #e0e0e0', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontFamily: 'sans-serif', color: '#666' }}>
                  Annuler
                </button>
              </div>
            </>
          )}
        </div>
      )}
      <button onClick={() => setOpen(!open)}
        style={{ padding: '7px 14px', background: open ? '#1A1A18' : '#fff', color: open ? '#fff' : '#666', border: '1px solid #e0e0e0', borderRadius: 20, fontSize: 12, cursor: 'pointer', fontFamily: 'sans-serif', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', whiteSpace: 'nowrap' }}>
        {open ? 'x' : isMob ? '!' : 'Signaler un dysfonctionnement'}
      </button>
    </div>
  );
}

/* ─── BackOfficeRoute ──────────────────────────────────── */
function BackOfficeRoute() {
  const [adminGranted, setAdminGranted] = useState(() => sessionStorage.getItem('admin_ok') === '1');
  const handleAdminAccess = () => { sessionStorage.setItem('admin_ok', '1'); setAdminGranted(true); };
  if (!adminGranted) return <AdminLoginPage onAdminAccess={handleAdminAccess} />;
  const handleAdminNavigate = (dest) => {
    if (dest === 'home') { sessionStorage.removeItem('admin_ok'); window.location.href = '/'; }
  };
  return <AdminPage onNavigate={handleAdminNavigate} />;
}

/* ─── Helpers ──────────────────────────────────────────── */
const isAdminFlow = () =>
  localStorage.getItem('admin_redirect') === '1' ||
  sessionStorage.getItem('admin_ok') === '1' ||
  sessionStorage.getItem('admin_pending') === '1' ||
  window.location.hash === '#/back-office-hv' ||
  new URLSearchParams(window.location.search).get('admin') === 'back-office-hv';

/* ─── App principal ────────────────────────────────────── */
export default function App() {
  const [page, setPage] = useState(() => {
  const hash = window.location.hash;
  const params = new URLSearchParams(window.location.search);
  console.log('PAGE PARAM:', params.get('page')); // ← ici
  if (hash.startsWith('#access_token=') && localStorage.getItem('admin_redirect') === '1') {
    localStorage.removeItem('admin_redirect');
    return 'back-office-hv';
  }
  if (hash === '#/back-office-hv' || params.get('admin') === 'back-office-hv') return 'back-office-hv';
  if (hash === '#/fondateurs') return 'fondateurs';
  if (hash === '#/conciergeries') return 'conciergeries';
  if (params.get('page') === 'owner-onboarding') return 'owner-onboarding';
  if (params.get('page') === 'owner-portal') return 'owner-portal';
  if (params.get('page') === 'hostdocs') return 'hostdocs';
  if (params.get('page') === 'newlisting') return 'newlisting';
  if (params.get('page') === 'dashboard') return 'dashboard';
  if (params.get('page') === 'review') return 'review';
  return 'home';
});
const [pageHistory, setPageHistory]         = useState([]);
const [selectedListing, setSelectedListing] = useState(null);
const [searchFilter, setSearchFilter]       = useState('');
const [authRedirect, setAuthRedirect]       = useState('home');
const [dashboardTab, setDashboardTab]       = useState('overview');
const [ownerOnboardingId, setOwnerOnboardingId] = useState(() => new URLSearchParams(window.location.search).get('owner_id') || null);
const [user, setUser]                       = useState(null);

  // ─── Routing principal ─────────────────────────────────
  useEffect(() => {
    const checkRoute = () => {
      const hash   = window.location.hash;
      const params = new URLSearchParams(window.location.search);

      if (params.get('page') === 'owner-portal') {
        const ownerId = params.get('owner_id');
        if (ownerId) setOwnerOnboardingId(ownerId);
        setPage('owner-portal');
        window.history.replaceState({}, '', '/');
        return;
      }

      if (hash.startsWith('#access_token=') && localStorage.getItem('admin_redirect') === '1') {
        localStorage.removeItem('admin_redirect');
        sessionStorage.removeItem('admin_pending');
        window.history.replaceState({}, '', '/');
        setPage('back-office-hv');
        return;
      }
      if (hash === '#/back-office-hv' || params.get('admin') === 'back-office-hv') {
        setPage('back-office-hv');
        return;
      }
      if (hash === '#/fondateurs') {
        setPage('fondateurs');
        window.history.replaceState({}, '', '/');
        return;
      }
      if (hash === '#/conciergeries') {
        setPage('conciergeries');
        window.history.replaceState({}, '', '/');
        return;
      }
      if (params.get('page') === 'owner-onboarding') {
        const ownerId = params.get('owner_id');
        if (ownerId) setOwnerOnboardingId(ownerId);
        setPage('owner-onboarding');
        window.history.replaceState({}, '', '/');
        return;
      }
      if (params.get('page') === 'review') {
  setPage('review');
  window.history.replaceState({}, '', '/');
  return;
}
if (params.get('page') === 'hostdocs') {
  setPage('hostdocs');
  window.history.replaceState({}, '', '/');
  return;
}
if (params.get('page') === 'newlisting') {
  setPage('newlisting');
  window.history.replaceState({}, '', '/');
  return;
}
if (params.get('page') === 'dashboard') {
  const tab = params.get('tab') || 'overview';
  setDashboardTab(tab);
  setPage('dashboard');
  window.history.replaceState({}, '', '/');
  return;
}
      
      if (params.get('stripe') === 'success' || params.get('stripe') === 'refresh') {
        setPage('dashboard');
        window.history.replaceState({}, '', '/');
        return;
      }
      if (params.get('listing')) {
        const listingId = params.get('listing');
        supabase
          .from('listings')
          .select('*')
          .eq('id', listingId)
          .single()
          .then(({ data }) => {
            if (data) {
              setSelectedListing(data);
              setPage('listing');
            } else {
              setPage('home');
            }
            window.history.replaceState({}, '', '/');
          });
        return;
      }
      if (hash.startsWith('#access_token=')) {
        window.history.replaceState({}, '', '/');
        return;
      }
    };

    checkRoute();
    window.addEventListener('hashchange', checkRoute);
    return () => window.removeEventListener('hashchange', checkRoute);
  }, []);

  // ─── Auth state — UN SEUL listener ────────────────────
  useEffect(() => {
    if (isAdminFlow()) return;

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (isAdminFlow()) return;
      setUser(session?.user ?? null);

      if (event === 'SIGNED_IN' && session) {
        const pendingUserType = localStorage.getItem('pending_user_type');
        if (pendingUserType) {
          localStorage.removeItem('pending_user_type');
          const isManager = pendingUserType === 'conciergerie';
          if (isManager) localStorage.setItem('havenly_is_manager', 'true');
          supabase.from('host_profiles').upsert({
            id: session.user.id,
            email: session.user.email,
            full_name: session.user.user_metadata?.full_name || '',
            is_manager: isManager,
            status: 'pending',
            level: 'havenly',
            commission_rate: 0.12,
            referral_credits: 0,
            updated_at: new Date().toISOString(),
          }, { onConflict: 'id' }).then(() => {
            if (isManager) setPage('dashboard');
          });
        }
        const r = localStorage.getItem('authRedirect');
        if (r) { localStorage.removeItem('authRedirect'); setPage(r); }
      }

      if (event === 'INITIAL_SESSION' && session) {
        const r = localStorage.getItem('authRedirect');
        if (r) { localStorage.removeItem('authRedirect'); setPage(r); }
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  // ─── Navigation ────────────────────────────────────────
  const goBack = () => {
    if (pageHistory.length === 0) { setPage('home'); return; }
    const prev = pageHistory[pageHistory.length - 1];
    setPageHistory(h => h.slice(0, -1));
    setPage(prev);
  };

  const navigate = (dest, data = null) => {
    if (dest === 'admin') return;
    if (dest !== page) setPageHistory(h => [...h.slice(-9), page]);
    if (dest === 'booking'    && data) setSelectedListing(data);
    if (dest === 'dashboard'  && data?.initialTab) setDashboardTab(data.initialTab);
    if (dest === 'listing'    && data) setSelectedListing(data);
    if (dest === 'newlisting') setSelectedListing(data && typeof data === 'object' ? data : null);
    if (dest === 'search'     && typeof data === 'string') setSearchFilter(data);
    if (dest === 'search'     && typeof data !== 'string') setSearchFilter('');
    if (dest === 'auth') {
      let redirectTo = 'home';
      if (data === 'host')         redirectTo = 'newlisting';
      else if (page === 'booking') redirectTo = 'booking';
      else if (page === 'listing') redirectTo = 'listing';
      setAuthRedirect(redirectTo);
      localStorage.setItem('authRedirect', redirectTo);
      setPage('auth');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    setPage(dest);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ─── Render ────────────────────────────────────────────
  if (page === 'back-office-hv') return <BackOfficeRoute />;
  if (page === 'owner-portal')   return <OwnerPortalPage ownerId={ownerOnboardingId} />;

  return (
    <>
      <Navbar page={page} onNavigate={navigate} onBack={goBack} />
      <SignalementButton page={page} />

      {user && page === 'home' && (
        <HostFounderPopup user={user} onNavigate={navigate} />
      )}

      {(page === 'fondateurs' || page === 'home' || page === 'auth') && (
        <ExitPopup page={page} />
      )}

      {page === 'home'              && <HomePage onNavigate={navigate} />}
      {page === 'search'            && <SearchPage onNavigate={navigate} searchFilter={searchFilter} onBack={goBack} />}
      {page === 'booking'           && (selectedListing
        ? <BookingPage listing={selectedListing} onNavigate={navigate} onBack={goBack} />
        : <div style={{ paddingTop: 100, textAlign: 'center', color: 'var(--ink-3)', fontFamily: 'var(--sans)', fontSize: 14 }}>
            Aucun logement selectionne. <button onClick={() => navigate('search')} style={{ color: 'var(--green)', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'var(--sans)', fontSize: 14 }}>Explorer</button>
          </div>
      )}
      {page === 'auth'              && <AuthPage onNavigate={navigate} redirect={authRedirect} onBack={goBack} />}
      {page === 'listing'           && <ListingPage listing={selectedListing} onNavigate={navigate} onBack={goBack} />}
      {page === 'dashboard'         && <DashboardPage onNavigate={navigate} onBack={goBack} initialTab={dashboardTab} />}
      {page === 'newlisting'        && <NewListingPage onNavigate={navigate} listing={selectedListing} onBack={goBack} />}
      {page === 'becomehost'        && <BecomeHostPage onNavigate={navigate} onBack={goBack} />}
      {page === 'referral'          && <ReferralPage onNavigate={navigate} onBack={goBack} />}
      {page === 'review'            && <ReviewPage onNavigate={navigate} onBack={goBack} />}
      {page === 'howitworks'        && <HowItWorksPage onNavigate={navigate} onBack={goBack} />}
      {page === 'hostdocs'          && <HostDocsPage onNavigate={navigate} onBack={goBack} />}
      {page === 'legal'             && <LegalPage onNavigate={navigate} legalPage={searchFilter} onBack={goBack} />}
      {page === 'voyageur'          && <VoyageurPage onNavigate={navigate} voyageurPage={searchFilter} onBack={goBack} />}
      {page === 'voyageur-home'     && <VoyageurPage onNavigate={navigate} onBack={goBack} />}
      {page === 'hote'              && <HotePage onNavigate={navigate} hotePage={searchFilter} onBack={goBack} />}
      {page === 'havenly'           && <HavenlyPage onNavigate={navigate} havenlyPage={searchFilter} onBack={goBack} />}
      {page === 'community'         && <CommunityPage onNavigate={navigate} communitySpace={searchFilter} onBack={goBack} />}
      {page === 'settings'          && <SettingsPage onNavigate={navigate} />}
      {page === 'mylistings'        && <MyListingsPage onNavigate={navigate} />}
      {page === 'mybookings'        && <MyBookingsPage onNavigate={navigate} />}
      {page === 'messages'          && <MessagesPage onNavigate={navigate} />}
      {page === 'fondateurs'        && <FoundeursPage onNavigate={navigate} />}
      {page === 'conciergeries'     && <ConciergeriePage onNavigate={navigate} />}
      {page === 'owner-onboarding'  && <OwnerOnboardingPage onNavigate={navigate} ownerId={ownerOnboardingId} />}
    </>
  );
}
